var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4029 19.0989H4.88073C5.82327 11.0672 12.6671 4.83325 20.9709 4.83325C29.9193 4.83325 37.1718 12.0723 37.1718 20.9999C37.1718 29.9275 29.9193 37.1666 20.9709 37.1666C12.6671 37.1666 5.82327 30.9326 4.88073 22.9009H26.4029H26.9029V22.4009V19.5989V19.0989H26.4029Z",
    fill: "url(#paint0_linear_554_1093)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.4029 19.0989H4.88073C5.82327 11.0672 12.6671 4.83325 20.9709 4.83325C29.9193 4.83325 37.1718 12.0723 37.1718 20.9999C37.1718 29.9275 29.9193 37.1666 20.9709 37.1666C12.6671 37.1666 5.82327 30.9326 4.88073 22.9009H26.4029H26.9029V22.4009V19.5989V19.0989H26.4029Z",
    stroke: "url(#paint1_linear_554_1093)",
    style: {
      mixBlendMode: "plus-lighter"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_554_1093",
    x1: 20.9999,
    y1: 4.33325,
    x2: 20.9999,
    y2: 37.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_554_1093",
    x1: 20.9999,
    y1: 4.33325,
    x2: 20.9999,
    y2: 37.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.07
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase);
export default __webpack_public_path__ + "static/media/base.7ed88d44937915b9dccd004be20aa9fa.svg";
export { ForwardRef as ReactComponent };